import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useEvents } from 'app/audiences/application'
import { Event } from 'app/audiences/types'
import { PagedList } from 'app/common/presentation/PagedList'
import { formatDateTime } from 'app/common/presentation/format'
import { DownloadIcon } from 'app/common/presentation/icons'

import { Section } from 'components'

import styles from './Events.module.scss'

interface EventsProps {
  audienceId: string
  className?: string
}

const pageSize = 6

const Events = ({ audienceId, className }: EventsProps) => {
  const { t } = useTranslation('audiences')
  const { getEvents } = useEvents(audienceId)
  const [events, setEvents] = useState<Event[]>([])

  useEffect(() => {
    void getEvents().then(setEvents)
  }, [audienceId, getEvents])

  return (
    <div className={className}>
      <Section name={t('details.events.title')} />
      <div className={styles.events}>
        <PagedList
          data={events}
          renderItem={(event, index) => (
            <div className={styles.row} key={index}>
              <DownloadIcon />
              <div className={styles.info}>
                <div className={styles.name}>{t(`details.events.name.${event.name}`)}</div>
                <div className={styles.description}>&nbsp;</div>
              </div>
              <div className={styles.date}>{formatDateTime(event.timestamp)}</div>
            </div>
          )}
          pageSize={pageSize}
        />
      </div>
    </div>
  )
}

export default Events
